import { motion } from "framer-motion";
import { UserPlus, GraduationCap, CalendarDays, Clock, Gauge, ConciergeBell, MessageSquare } from "lucide-react";
import AriOrb from "@/components/ari/AriOrb";

const EASE = [0.16, 1, 0.3, 1];
const AriGlyph = () => <AriOrb size={24} state="insight" />;

const NODES = [
  { icon: UserPlus, label: "Employee joins", sub: "One profile, instantly" },
  { icon: GraduationCap, label: "Auto-onboarding & training", sub: "Role-based, no admin" },
  { icon: CalendarDays, label: "Added to the rota", sub: "Labour-cost aware" },
  { icon: Clock, label: "Attendance tracked", sub: "Straight into payroll" },
  { icon: Gauge, label: "Performance monitored", sub: "Skill gaps surfaced" },
  { icon: ConciergeBell, label: "Guests connect at the table", sub: "Requests routed live" },
  { icon: AriGlyph, label: "ARI analyses operations", sub: "Across every domain" },
  { icon: MessageSquare, label: "You get recommendations", sub: "The next best action" },
];

export const EcosystemFlow = () => (
  <div className="relative" data-testid="ecosystem-flow">
    {/* vertical gold spine that grows on scroll */}
    <motion.div
      className="absolute left-[27px] sm:left-1/2 sm:-translate-x-1/2 top-2 bottom-2 w-px origin-top bg-gradient-to-b from-transparent via-[#D4AF37]/60 to-transparent"
      initial={{ scaleY: 0, opacity: 0 }}
      whileInView={{ scaleY: 1, opacity: 1 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 1.4, ease: EASE }}
    />
    <div className="space-y-5 sm:space-y-8">
      {NODES.map((n, i) => (
        <motion.div
          key={n.label}
          className={`relative flex items-center gap-5 sm:gap-8 ${i % 2 === 1 ? "sm:flex-row-reverse sm:text-right" : ""}`}
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.7, ease: EASE, delay: i * 0.08 }}
        >
          {/* node marker */}
          <div className="relative z-10 shrink-0 sm:mx-auto">
            <div className="w-14 h-14 rounded-2xl bg-[#141416] ring-1 ring-[#D4AF37]/30 flex items-center justify-center shadow-[0_0_30px_-8px_rgba(212,175,55,0.4)]">
              <n.icon className="w-6 h-6 text-[#D4AF37]" />
            </div>
          </div>
          {/* label card */}
          <div className={`lux-card flex-1 sm:max-w-[42%] px-5 py-4 ${i % 2 === 1 ? "sm:ml-auto" : ""}`}>
            <p className="text-[10px] font-mono-lux uppercase tracking-[0.2em] text-white/35 mb-1">Step {String(i + 1).padStart(2, "0")}</p>
            <p className="text-white font-medium leading-tight">{n.label}</p>
            <p className="text-sm text-white/50 mt-1">{n.sub}</p>
          </div>
        </motion.div>
      ))}
    </div>
  </div>
);
